import { ToggleLabel, ToggleWrapper } from '@econsult/econsult-ui/dist/components/Toggle/toggleStyles';
import { TextAreaWrapper } from 'components/CustomClosureMessage/style';
import { SettingDetail } from 'components/Setting/style';
import { Divider } from 'components/Typography';
import styled from 'styled-components';

export const CustomMessageToggleSettingDetail = styled(SettingDetail)`
  align-content: end;
`;

export const CustomMessageToggleWrapper = styled.div`
  position: relative;

  ${ToggleWrapper} {
    --toggle-size: 1.5rem;
    --handle-size: 1.125rem;
  }

  ${ToggleLabel} {
    font-size: 14px;
    color: ${({ theme }) => theme.colorPrimaryPrimary100};
  }
`;

export const CustomMessageTextareaWrapper = styled(TextAreaWrapper)`
  ${Divider} {
    height: 0;
    margin-bottom: 0;
  }
`;
